import React from "react";

const MAP = {
  complaint_filed: { label: "Complaint Filed", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  response_pending: { label: "Response Pending", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  under_discussion: { label: "Under Discussion", cls: "bg-purple-50 text-purple-800 border-purple-200" },
  evidence_submitted: { label: "Evidence Submitted", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  resolution_proposed: { label: "Resolution Proposed", cls: "bg-cyan-50 text-cyan-800 border-cyan-200" },
  resolved_by_agreement: { label: "Resolved by Agreement", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  unresolved: { label: "Unresolved", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  no_response: { label: "No Response Received", cls: "bg-orange-50 text-orange-800 border-orange-200" },
  withdrawn: { label: "Withdrawn", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  closed: { label: "Closed", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  under_moderation: { label: "Under Moderation", cls: "bg-yellow-50 text-yellow-800 border-yellow-200" },
  under_appeal: { label: "Under Appeal", cls: "bg-fuchsia-50 text-fuchsia-800 border-fuchsia-200" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span
      data-testid="dispute-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${s.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s.label}
    </span>
  );
}
